import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ProductoService } from 'app/services/producto.service';
import { ArticuloProveedorService } from 'app/services/articuloproveedor.service';
import { ArticuloProveedor } from 'app/models/articuloproveedor.models';
import { Client } from 'app/models/client.models';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ProveedorDialogComponent } from '../proveedor-dialog/proveedor-dialog.component';

@Component({
  selector: 'app-proveedor-tab',
  templateUrl: './proveedor-tab.component.html',
  styleUrls: ['./proveedor-tab.component.css']
})
export class ProveedorTabComponent implements OnInit, OnChanges {
  @Input() idProducto: number;
  @Input() tempProveedores: Client[] = []; // Para productos nuevos
  @Input() isNewProduct: boolean = false;
  @Output() onAgregarProveedorTemporal = new EventEmitter<Client>();
  @Output() onEliminarProveedorTemporal = new EventEmitter<number>();

  proveedoresDataSource = new MatTableDataSource<ArticuloProveedor>([]);
  proveedoresTemporalesDataSource = new MatTableDataSource<Client>([]);

  constructor(
    private productoService: ProductoService,
    public dialog: MatDialog,
    private articuloProveedorService: ArticuloProveedorService
  ) {}

  ngOnInit(): void {
    this.cargarProveedores();
    this.actualizarProveedoresTemporales();
  }

  ngOnChanges(): void {
    this.actualizarProveedoresTemporales();
  }

  actualizarProveedoresTemporales() {
    this.proveedoresTemporalesDataSource.data = this.tempProveedores || [];
  }

  cargarProveedores() {
    // Solo cargar proveedores si hay un ID de producto (producto existente)
    if (!this.idProducto) {
      this.proveedoresDataSource.data = [];
      return;
    }
    this.productoService.getProveedorByArticulo(this.idProducto).subscribe((res) => {
      this.proveedoresDataSource.data = res || [];
    });
  }

  abrirDialogoProveedor() {
    const dialogRef = this.dialog.open(ProveedorDialogComponent, {
      width: '400px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.proveedorId) {
        if (this.isNewProduct) {
          // Para productos nuevos, agregar a la lista temporal
          this.onAgregarProveedorTemporal.emit(result.proveedorId);
        } else {
          // Para productos existentes, guardar directamente
          this.articuloProveedorService.addProveedorArticulo(this.idProducto, result.proveedorId.id).subscribe(() => {
            this.cargarProveedores();
          });
        }
      }
    });
  }

  editarProveedor(proveedor: ArticuloProveedor) {
    const dialogRef = this.dialog.open(ProveedorDialogComponent, {
      width: '400px',
      data: {
        proveedorId: proveedor.supplier?.id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const data = {
          proveedorId: result.proveedorId.id,
          fecha: new Date()
        };
        this.articuloProveedorService.updateProveedorArticulo(proveedor['id'], data).subscribe(() => {
          this.cargarProveedores();
        });
      }
    });
  }

  eliminarProveedor(proveedor: ArticuloProveedor) {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este proveedor del artículo?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.articuloProveedorService.deleteProveedorArticulo(proveedor.article?.id, proveedor.supplier?.id).subscribe(() => {
          this.cargarProveedores();
        });
      }
    });
  }

  eliminarProveedorTemporal(proveedor: Client) {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este proveedor temporal?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.onEliminarProveedorTemporal.emit(proveedor.id);
      }
    });
  }

}
